import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import FormPage from './pages/FormPage';
import ThankYouPage from './pages/ThankYouPage';
import Internship from './pages/InternshipProgram';
import logo from './assets/logo.png';
// import './App.css';

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 flex flex-col items-center">
        <nav className="bg-white w-full p-3 text-white mb-6 drop-shadow-lg justify-items-center align-item-center">
          {/* <ul className="flex justify-center space-x-4">
            <li>
              <Link to="/" className="hover:text-gray-200">
                Home
              </Link>
            </li>
            <li>
              <Link to="/form" className="hover:text-gray-200">
                Contact Form
              </Link>
            </li>
          </ul> */}

          <div className="flex">
            <Link to="https://muskowl.com" className="">
              <img className="w-[100px]" src={logo} alt="Muskowl LLP" />
            </Link>
            <Link
              to="https://muskowl.com"
              className="text-black items-center flex ml-[30px] hover:text-gray-400"
            >
              Home
            </Link>
          </div>
        </nav>
        <Routes>
          <Route
            path="mo/"
            element={<h1 className="text-3xl">Welcome to My App</h1>}
          />
          <Route path="/form" element={<FormPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/internship-program" element={<Internship />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
